import React from 'react';
import {
    Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Tooltip, Filler,
} from 'chart.js';
import { Bar, Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Tooltip, Filler);

const BRAND = '#03b463';

// Minimal themed bar / area chart. `format` formats tooltip + axis values.
const TrendChart = ({ type = 'bar', labels = [], data = [], label = '', color = BRAND, height = 260, format = (v) => v }) => {
    const dataset = type === 'bar'
        ? { label, data, backgroundColor: color, borderRadius: 6, maxBarThickness: 28 }
        : {
            label,
            data,
            borderColor: color,
            borderWidth: 2.5,
            pointRadius: 0,
            pointHoverRadius: 4,
            tension: 0.35,
            fill: true,
            backgroundColor: (ctx) => {
                const { chart } = ctx;
                if (!chart.chartArea) return 'transparent';
                const g = chart.ctx.createLinearGradient(0, chart.chartArea.top, 0, chart.chartArea.bottom);
                g.addColorStop(0, `${color}33`);
                g.addColorStop(1, `${color}00`);
                return g;
            },
        };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: 'index', intersect: false },
        plugins: {
            legend: { display: false },
            tooltip: {
                backgroundColor: '#0f1d2b',
                padding: 10,
                cornerRadius: 8,
                displayColors: false,
                callbacks: { label: (ctx) => `${label}: ${format(ctx.parsed.y)}` },
            },
        },
        scales: {
            x: { grid: { display: false }, border: { display: false }, ticks: { color: '#8a98a8', font: { size: 12 } } },
            y: {
                beginAtZero: true,
                grid: { color: '#eef2f6' },
                border: { display: false },
                ticks: { color: '#8a98a8', font: { size: 12 }, precision: 0, maxTicksLimit: 5, callback: (v) => format(v) },
            },
        },
    };

    const Chart = type === 'bar' ? Bar : Line;
    return (
        <div style={{ position: 'relative', height }}>
            <Chart data={{ labels, datasets: [dataset] }} options={options} />
        </div>
    );
};

export default TrendChart;
